import { useDetectImageryForProject } from 'projectSections/sections/design/util/useDetectImageryForProject'
import { useRestartDesignMode } from 'projectSections/sections/design/util/useRestartDesignMode'

export const ProjectPersistentContent = () => {
  // Used to remove the views and restart when DSM fails to load
  window.AccountHelper.getMapTypesForProject = useDetectImageryForProject()
  // Used to remove the views and restart when DSM fails to load
  window.Designer.restartDesignMode = useRestartDesignMode()

  return <></>
}
